<template>
  <a-layout-footer class="layout-footer">
    <div class="copyright">
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">京ICP备19040055号-1</a>
    </div>
  </a-layout-footer>
</template>

<script>
export default {
  name: 'LayoutFooter'
}
</script>

<style lang="scss" scoped>
  .layout-footer {
    text-align: center;
    user-select: none;
    background-color: transparent;
    padding: 0 !important;
    // pointer-events: none;
  }

  .copyright {
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;

    a {
      color: #000000a6;
    }
  }
</style>
